export const colorOptions = [
    { name: 'Yellow', class: 'bg-yellow-200', glowColor: 'rgba(202, 138, 4, 0.3)' },
    { name: 'Green', class: 'bg-green-200', glowColor: 'rgba(22, 163, 74, 0.3)' },
    { name: 'Blue', class: 'bg-blue-200', glowColor: 'rgba(37, 99, 235, 0.3)' },
    { name: 'Red', class: 'bg-red-200', glowColor: 'rgba(220, 38, 38, 0.3)' },
    { name: 'Purple', class: 'bg-purple-200', glowColor: 'rgba(147, 51, 234, 0.3)' },
];

export const getGlowColor = (colorClass, isPastDue = false) => {
    if (isPastDue) {
        return 'rgba(239, 68, 68, 0.5)'; // Red glow for past due notes
    }
    const colorOption = colorOptions.find(option => option.class === colorClass);
    return colorOption?.glowColor || 'rgba(147, 51, 234, 0.3)'; // Default to purple if not found
};